import { PrepareTaskTypes } from '@/types';
import { WalletType } from '@web3/base-utils';

export const ethAddress = 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';

// 无需校验的任务configid
export const filterConfigId = [230, 250];

// prepare类型任务（原充值任务）: 充值任务：101，swap任务：110
export const prepareTaskType = [
  PrepareTaskTypes.deposit,
  PrepareTaskTypes.swap,
];

// console.log('123')

// 钱包类型对应多语言key
export const WalletTypeTextKey = {
  [WalletType.NOT]: 'no wallet',
  [WalletType.CLOUD]: 'bybitCloudWallet',
  [WalletType.MPC]: 'MPCWallet',
  [WalletType.AA]: 'AAWallet',
  [WalletType.PRIVATE_KEY]: 'bybitPrivateKeyWallet',
  [WalletType.MNEMONIC_PHRASE]: 'bybitMnemonicWallet',
  [WalletType.FOLLOW_ADDRESS]: 'bybitFollowAddressWallet',
  [WalletType.THIRD_PARTY]: 'metaMaskOrOtherWallet',
};

// bybit插件钱包类型
export const BybitWalletEx = [
  WalletType.PRIVATE_KEY,
  WalletType.MNEMONIC_PHRASE,
];
